import { render, staticRenderFns } from "./AuthShell.vue?vue&type=template&id=40b2a1fa&scoped=true&"
import script from "./AuthShell.vue?vue&type=script&lang=js&"
export * from "./AuthShell.vue?vue&type=script&lang=js&"
import style0 from "./AuthShell.vue?vue&type=style&index=0&id=40b2a1fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2a1fa",
  null
  
)

export default component.exports